(function () {
    function shouldShowButtonBlock() {
      // Check if we are on the get-inspired page
      const isGetInspiredPage =
        window.location.pathname.includes('/pages/get-inspired') ||
        window.location.pathname === '/pages/get-inspired' ||
        window.location.pathname.endsWith('/get-inspired');

      if (!isGetInspiredPage) {
        return false;
      }

      // Get the category parameter from the URL
      const urlParams = new URLSearchParams(window.location.search);
      const categoryParam = urlParams.get('category');

      // If there is no category parameter, default is idea-house
      // If the category parameter is idea-house, show the section
      if (!categoryParam || categoryParam === 'idea-house') {
        return true;
      }

      return false;
    }

    function toggleButtonBlock() {
      // Find all button block sections using the data attribute
      const buttonBlockContainers = document.querySelectorAll('[data-button-block-section]');
      
      buttonBlockContainers.forEach(function(container) {
        const sectionId = container.getAttribute('data-section-id');
        if (!sectionId) return;
        
        const section = document.getElementById('shopify-section-' + sectionId);
        if (!section) return;

        if (shouldShowButtonBlock()) {
          section.classList.add('show-button-block');
        } else {
          section.classList.remove('show-button-block');
        }
      });
    }

    // Execute on page load
    function init() {
      toggleButtonBlock();

      // Listen for URL changes (browser navigation)
      window.addEventListener('popstate', toggleButtonBlock);

      // Listen for changes when URL is updated with pushState
      const originalPushState = history.pushState;
      history.pushState = function () {
        originalPushState.apply(history, arguments);
        setTimeout(toggleButtonBlock, 100);
      };

      // Listen for changes when URL is updated with replaceState
      const originalReplaceState = history.replaceState;
      history.replaceState = function () {
        originalReplaceState.apply(history, arguments);
        setTimeout(toggleButtonBlock, 100);
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();